import { render, staticRenderFns } from "./LiveReceptionistItem.vue?vue&type=template&id=1fcf7c3b"
import script from "./LiveReceptionistItem.vue?vue&type=script&lang=js"
export * from "./LiveReceptionistItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports